module.exports = "/images/tibet.svg?031e1a717ef0745508d12ec152823009";